module.exports = __webpack_public_path__ + "static/media/springwater-condo.93b75644.pdf";